var _this = this,
    _jsxFileName = "/Users/michaelschlecht/Documents-CCM/dev/ccm-innovation/pricing-components/src/components/PricingTableClassic/PricingTableClassic.js";

import React from 'react';
import { PropTypes } from 'prop-types';
import ReactTooltip from 'react-tooltip';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import "./PricingTableClassic.scss";
import * as Utils from '../../utils/shared-utils';

var PricingTableClassic = function PricingTableClassic(props) {
  var sortAhpAscending = props.sortAhpAscending,
      renderHealthyMonthlyShare = props.renderHealthyMonthlyShare;

  var formatPlans = function formatPlans(planOptions) {
    if (planOptions.length > 0) {
      planOptions = _.orderBy(planOptions, ['ahpAmount'], [sortAhpAscending ? 'asc' : 'desc']);
      var ahpFormatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 0
      });
      var shareAmountFormatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2
      });
      planOptions.forEach(function (plan) {
        plan.ahpAmount = ahpFormatter.format(plan.ahpAmount);
        plan.totalAmount = shareAmountFormatter.format(plan.totalAmount);
        plan.healthyDiscountTotalAmount = typeof plan.healthyDiscountTotalAmount === 'string' || plan.healthyDiscountTotalAmount instanceof String ? plan.healthyDiscountTotalAmount : shareAmountFormatter.format(plan.healthyDiscountTotalAmount);
      });
    }

    return planOptions;
  };

  var renderPlanRows = function renderPlanRows(planOptions) {
    var planRows = [];
    planOptions.forEach(function (plan, index) {
      var isEven = false;
      if (index % 2 === 0) isEven = true;
      planRows.push( /*#__PURE__*/React.createElement("tr", {
        key: plan.ahpAmount,
        className: "tr-classic" + (isEven ? ' even' : ''),
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 46,
          columnNumber: 9
        }
      }, /*#__PURE__*/React.createElement("td", {
        className: "td-classic first-classic",
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 47,
          columnNumber: 11
        }
      }, plan.ahpAmount), /*#__PURE__*/React.createElement("td", {
        className: "td-classic",
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 48,
          columnNumber: 11
        }
      }, plan.totalAmount), renderHealthyMonthlyShare === true && /*#__PURE__*/React.createElement("td", {
        className: "td-classic",
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 51,
          columnNumber: 13
        }
      }, /*#__PURE__*/React.createElement("em", {
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 51,
          columnNumber: 40
        }
      }, plan.healthyDiscountTotalAmount))));
    });
    return planRows;
  };

  var programLevels = Utils.copyObj(props.planOptions.programs[0].programLevels);
  var planRows = renderPlanRows(formatPlans(programLevels));
  return /*#__PURE__*/React.createElement("div", {
    className: "ccm-pricing-table-wrapper-classic",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 64,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement("h2", {
    className: "h2-classic",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 65,
      columnNumber: 7
    }
  }, "Medi-Share Program Options"), /*#__PURE__*/React.createElement("div", {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 66,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement("table", {
    className: "table-classic",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 67,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement("tbody", {
    className: "tbody-classic",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 68,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement("tr", {
    className: "tr-classic",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 69,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement("td", {
    className: "th-classic first-classic",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 70,
      columnNumber: 15
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-for": "ahp-header",
    "data-tip": "Instead of an insurance deductible, each member\u2019s household selects an Annual Household Portion (AHP) that they must pay during a 12 month period based on the date their membership began. After the AHP has been paid, provider bills for services rendered during that 12 month period may be eligible for sharing. For additional information, see Share Amount Details below.",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 71,
      columnNumber: 17
    }
  }, "Annual Household Portion", /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    className: "info-circle-classic",
    icon: "info-circle",
    size: "lg",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 76,
      columnNumber: 19
    }
  }))), /*#__PURE__*/React.createElement("td", {
    className: "th-classic first-classic",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 82,
      columnNumber: 15
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-for": "standard-monthly-share-header",
    "data-tip": "Medi-Share is not insurance so members do not pay monthly insurance \u201Cpremiums\u201D or \u201Crates\u201D. Instead, each member household opens an account and deposits a monthly share with a CCM Financial Partner. For additional information, see Share Amount Details below.\n                  <br/> <br/>\n                  Certain health conditions (like high cholesterol, excess weight, or diabetes) qualify applicants for our <a href='https://mychristiancare.org/medi-share/what-is-medishare/health-and-wellness/health-partners/' class='tooltiptext-link-classic'>Health Partner</a> program, which includes an additional $99 per month fee.",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 83,
      columnNumber: 17
    }
  }, "Standard Monthly Share", /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    className: "info-circle-classic",
    icon: "info-circle",
    size: "lg",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 90,
      columnNumber: 19
    }
  }))), renderHealthyMonthlyShare === true && /*#__PURE__*/React.createElement("td", {
    className: "th-classic first-classic",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 98,
      columnNumber: 17
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-for": "healthy-monthly-share-header",
    "data-tip": "The healthy monthly share is the reduced monthly share amount (3%) for members who meet certain health standards. Learn more about qualifying (or applying) for the <a href='https://mychristiancare.org/medi-share/what-is-medishare/health-and-wellness/health-incentive/' class='tooltiptext-link-classic'>Health Incentive</a> discount.",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 99,
      columnNumber: 19
    }
  }, "*Healthy Monthly Share", /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    className: "info-circle-classic",
    icon: "info-circle",
    size: "lg",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 104,
      columnNumber: 21
    }
  })))), planRows))), /*#__PURE__*/React.createElement("div", {
    className: 'tooltips-classic',
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 116,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(ReactTooltip, {
    id: "ahp-header",
    className: "ahp-header tooltiptext-classic",
    delayHide: 250,
    effect: "solid",
    html: true,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 117,
      columnNumber: 9
    }
  }), /*#__PURE__*/React.createElement(ReactTooltip, {
    id: "standard-monthly-share-header",
    className: "standard-monthly-share-header tooltiptext-classic",
    delayHide: 250,
    effect: "solid",
    html: true,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 124,
      columnNumber: 9
    }
  }), /*#__PURE__*/React.createElement(ReactTooltip, {
    id: "healthy-monthly-share-header",
    className: "healthy-monthly-share-header tooltiptext-classic",
    delayHide: 250,
    effect: "solid",
    html: true,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 131,
      columnNumber: 9
    }
  })));
};

PricingTableClassic.defaultProps = {
  sortAhpAscending: false,
  renderHealthyMonthlyShare: true
};
PricingTableClassic.propTypes = process.env.NODE_ENV !== "production" ? {
  planOptions: PropTypes.object.isRequired,
  sortAhpAscending: PropTypes.bool,
  renderHealthyMonthlyShare: PropTypes.bool
} : {};
export default PricingTableClassic;